var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentHits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6441_460034)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8915 11.4783C19.963 10.9959 20 10.5023 20 10C20 8.57779 19.7031 7.22492 19.1679 6H24V11.4783H19.8915ZM18.5217 15.2353C19.0795 14.3294 19.4968 13.3278 19.7434 12.2609H24V17.7391H18.5217V15.2353ZM16.3334 17.7391C16.8471 17.3182 17.3182 16.8471 17.7391 16.3334V17.7391H16.3334ZM12.2609 19.7434C13.3278 19.4968 14.3294 19.0795 15.2353 18.5217H17.7391V24H12.2609V19.7434ZM6 19.1679C7.22492 19.7031 8.57779 20 10 20C10.5023 20 10.9959 19.963 11.4783 19.8915V24H6V19.1679ZM24 18.5217H18.5217V24H24V18.5217Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "#FEFEFE",
    stroke: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2.3501L16.8981 6.21335L13.4473 7.92506L10.9271 4.63697L15 2.3501ZM10.8136 4.87576L13.2787 8.09198L12.0829 12.0213L11.2014 6.6543L11.1887 6.57685L11.1271 6.52354L10.8206 6.25832L10.7601 5.00799L10.8136 4.87576ZM12.7562 13.8728L12.7726 13.8842L14.2798 9.78294L12.7562 13.8728ZM14.2826 9.77923L16.0302 8.76839L16.0376 8.7512L14.2826 9.77923ZM11.8678 12.1977L11.8237 12.2665L11.0835 11.6917L10.8361 6.5786L10.9629 6.68832L11.8678 12.1977ZM12.5536 13.7311L12.5313 13.7156L12.2297 13.3221L12.171 12.5561L13.5126 8.14738L16.8004 6.51656L16.1874 8.39783L14.1523 9.58993L14.0806 9.63196L14.0528 9.70657L12.5536 13.7311Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2826 9.77927L16.0301 8.76843L16.0376 8.75124L14.2826 9.77927ZM12.5521 13.735L12.5313 13.7156L12.2297 13.3221L12.171 12.5561L13.5126 8.14743L16.8004 6.5166L16.1874 8.39787L14.1523 9.58998L14.0806 9.63201L14.0528 9.70662L12.5521 13.735Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2.3501L16.8981 6.21335L13.4473 7.92506L10.9271 4.63697L15 2.3501Z",
    fill: "#559CFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14038 7.98072L6.44026 2.89267L9.38617 12.8911L9.27377 13.0408L7.70532 8.93685L5.14038 7.98072ZM12.0158 13.0533L10.5406 11.3542L9.5659 12.6519L6.66586 2.80908L10.9639 6.71047L12.0158 13.0533Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8.08805L6.29988 3L9.0119 12.2046L9.13339 13.1481L7.56494 9.04418L5 8.08805Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4312 18.6583L16.8571 17.7104L18.1217 15.9006L14.1186 17.8946L13.4312 18.6583ZM14.4698 17.4646L17.8747 15.7687L15.7739 15.9164L14.7194 17.1448L14.4698 17.4646Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2832 17.8946L18.2863 15.9006L17.0217 17.7104L13.5958 18.6583L14.2832 17.8946Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99358 18.2793L3.4826 15.9973L7.74002 17.8334L8.00698 18.1568L8.3086 18.4379L8.88189 18.9721L4.99358 18.2793ZM5.87794 15.5828L7.40373 17.426L7.42242 17.4486L3.61609 15.807L5.87794 15.5828Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99358 18.1556L3.4826 15.8735L7.74002 17.7097L8.00698 18.0331L8.3086 18.3142L8.88189 18.8484L4.99358 18.1556ZM7.1545 17.2094L7.40373 17.3023L7.42242 17.3249L7.1545 17.2094Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6031 7.25513L18.8226 12.1146L15.2904 12.5261L14.3111 9.78844L14.3211 9.76197L18.6031 7.25513ZM14.1807 10.1349L15.0773 12.6416L12.6527 17.3624L12.9536 14.39L12.7726 13.884L12.7977 13.8082L14.1807 10.1349ZM13.0999 18.9999L12.471 18.9999L12.579 18.0267L15.2876 12.7531L18.6253 12.3643L13.0999 18.9999Z",
    fill: "#559CFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1807 10.1351L15.0773 12.6418L12.6527 17.3626L12.9536 14.3902L12.7726 13.8842L12.7974 13.809L14.1807 10.1351Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0999 18.9999L12.471 18.9999L12.5259 18.1301L15.2876 12.7531L18.6253 12.3642L13.0999 18.9999Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42033 12.3731L7.58719 9.35874L8.95158 12.9189L9.09281 13.3221L8.54988 14.1653L9.09281 16.1892L9.90224 18.2845L6.42033 12.3731ZM7.88357 17.7311L9.0253 18.9734L10.0327 18.9734L6.2179 12.4967L3.13629 12.5655L4.033 13.5413L6.01624 15.4021L7.88357 17.7311ZM3 12.3437L6.20289 12.2721L7.43463 9.09016L3.00001 7.4458L3 12.3437Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0253 18.5276L10.0327 18.5276L6.2179 12.0509L3.13629 12.1197L4.033 13.0955L6.01624 14.9563L7.88357 17.2853L9.0253 18.5276ZM3 11.8979L6.20289 11.8263L7.43463 8.64436L3.00001 7L3 11.8979Z",
    fill: "#559CFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0253 18.9733L10.0327 18.9733L6.2179 12.4966L3.13629 12.5654L4.03295 13.541L6.01625 15.402L7.88364 17.731L9.0253 18.9733Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3064 18.9605L12.7654 14.6616L10.9936 16.1671L11.3979 18.9646L12.3064 18.9605ZM11.1544 18.9644L10.7518 16.179L8.87371 14.5707L10.2738 18.9605L11.1544 18.9644ZM10.8659 15.9713L8.7912 14.1946L10.5532 11.7314L12.7529 14.3679L10.8659 15.9713Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1544 18.9644L10.7518 16.179L8.87371 14.5707L10.2738 18.9605L11.1544 18.9644ZM10.8659 15.9713L8.7912 14.1946L10.5532 11.7314L12.7529 14.3679L10.8659 15.9713Z",
    fill: "#559CFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1544 18.9645L10.7518 16.1791L8.87372 14.5708L10.2738 18.9606L11.1544 18.9645Z",
    fill: "#0059CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6441_460034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentHits);
export default __webpack_public_path__ + "static/media/Experiment_Hits.4bf9f2fa4d35955e10458ae289e01d31.svg";
export { ForwardRef as ReactComponent };